<mg-xls-list-uploader
  [fields]="fields"
  [file]="files$ | async"
  (listSubmitted)="onSubmit($event)"
  [allowDuplicateRows]="allowDuplicateRows"
  [allowNoIdField]="allowNoIdfield"
  [onValidate]="onValidate">
</mg-xls-list-uploader>
